import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import type React from 'react';
type FormInputAddonSize = 'default' | 'compact' | 'tiny';
type FormInputAddonProps = {
  children: React.ReactNode;
  size?: FormInputAddonSize;
  disabled?: boolean;
};
const FormInputAddon = t0 => {
  const $ = _c(8);
  const {
    children,
    size: t1,
    disabled: t2
  } = t0;
  const size = t1 === undefined ? "default" : t1;
  const disabled = t2 === undefined ? false : t2;
  const isChildrenString = typeof children === "string";
  const t3 = !isChildrenString;
  let t4;
  if ($[0] !== isChildrenString || $[1] !== t3) {
    t4 = cx("fp-input-addon flex items-center relative text-body-2 rounded-l", {
      "rounded-br-none rounded-tr-none border-r-0 border-1 border-tertiary px-4 py-1": isChildrenString,
      "p-0 border-0 [&_button]:!bg-transparent [&_button]:!rounded-r-none [&_button]:!border-r-0": t3
    });
    $[0] = isChildrenString;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== children || $[4] !== disabled || $[5] !== size || $[6] !== t4) {
    t5 = <div data-size={size} data-disabled={disabled} className={t4}>{children}</div>;
    $[3] = children;
    $[4] = disabled;
    $[5] = size;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export default FormInputAddon;